import { getTimeZoneOptions } from '../config/client.time-zones.config';

// `timeZone` is stored as an IANA id. One outside the curated seven (the column is free text) is
// shown as stored rather than blanked, so the clinician still sees what the record holds.
export function formatTimeZone(timeZone: string | null): string {
    if (!timeZone) return '';

    return getTimeZoneOptions().find((option) => option.value === timeZone)?.label ?? timeZone;
}
